

import React from 'react'


const SubscriptionSettings = () => {
  return (
   <div className="border-2 border-gray-200 rounded-2xl mx-10 h-[50vh]">
      <div className='p-5 border-b-2 border-gray-200 text-gray-500 font-bold text-lg'>
        Subscription Settings
      </div>

      <div className='flex items-center justify-around text-sky-500 mt-10'>
        <p>List Available Subscription</p>
        <p>Select Required Subscription</p>
        <p>Apply the subscription and expiry date</p>
        <p>Confirm With admin password</p>
      </div>
     </div>
  )
}

export default SubscriptionSettings;
